import React, { useEffect, useRef, useState } from "react";
import "./style.scss";

import bag_decor_img from "assets/imgs/BanmoiMyVNPT/right_decor.png";
import vnpt_logo_desktop from "assets/imgs/CTKMT7/Logo_VNPT.png";
import stepGetVoucher1 from "assets/imgs/BanmoiMyVNPT/iPhone14-1.png";
import stepGetVoucher3 from "assets/imgs/BanmoiMyVNPT/iPhone14-2.png";
import stepGetVoucher2 from "assets/imgs/BanmoiMyVNPT/iPhone14-3.png";
import stepGetVoucher4 from "assets/imgs/BanmoiMyVNPT/iPhone14-4.png";
import myvnpt_logo from "assets/imgs/CTKMT7/Logo_MyVNPT_Footer.png";
import qrcode from "assets/icons/QRStore.svg";
import iosStore from "assets/imgs/appstore.png";
import androiStore from "assets/imgs/ggplay.png";

import iconVNPT from "assets/icons/icon-vnpt.svg";
import banner from "assets/imgs/BanmoiMyVNPT/banner-ban-moi.jpg";
import icon_add_user from "assets/imgs/bulleticons/add-user.svg";
import icon_calendar from "assets/imgs/bulleticons/bullet_calendar_ic.png";
import icon_coupon from "assets/imgs/bulleticons/bullet_coupon_ic.png";
import icon_dual_sim from "assets/imgs/bulleticons/bullet_dual_sim_ic.png";

import { CTKM_NEWS_ID, env_set } from "global/environment";
import Swiper from 'react-id-swiper';

const BanmoiMyVNPT = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth > 991 ? false : true);
  const swiperRef = useRef(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const STORE_IOS = "https://apps.apple.com/vn/app/my-vnpt/id1017188399?l=vi";
  const STORE_ANDROID =
    "https://play.google.com/store/apps/details?id=com.vnp.myvinaphone&hl=vi";

  useEffect(() => {
    const handleLoad = () => {
      if (window.innerWidth > 991) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    };
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    };
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("load", handleLoad);
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const defaftParamsVoucher = {
    slidesPerView: 4,
    spaceBetween: 32,
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    on: {
      slideChange: () => {
        if (swiperRef.current && swiperRef.current.swiper) {
          setIsBeginning(swiperRef.current.swiper.isBeginning);
          setIsEnd(swiperRef.current.swiper.isEnd);
        }
      },
    },
    breakpoints:{
      290: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      370: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 4,
      },
    }
  };

  const defaftParamsCard = {
    slidesPerView: 4,
    spaceBetween: 32,
    on: {
      slideChange: () => {
        if (swiperRef.current && swiperRef.current.swiper) {
          setIsBeginning(swiperRef.current.swiper.isBeginning);
          setIsEnd(swiperRef.current.swiper.isEnd);
        }
      },
    },
    breakpoints:{
      290: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      370: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 4,
      },
    }
  };

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      setIsBeginning(swiperRef.current.swiper.isBeginning);
      setIsEnd(swiperRef.current.swiper.isEnd);
    }
  }, []);

  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      if (swiperRef.current.swiper?.isEnd) {
        // swiperRef.current.swiper.slideTo(0);
      } else {
        swiperRef.current.swiper.slideNext();
      }
    }
  };

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      if (swiperRef.current.swiper.isBeginning) {
        // swiperRef.current.swiper.slideTo(swiperRef.current.swiper.slides.length - 1);
      } else {
        swiperRef.current.swiper.slidePrev();
      }
    }
  };

  const listStepGetVoucher = [
    {
      image: stepGetVoucher1,
      desc: `<b>Bước 1:</b> Tải ứng dụng <span class="semi-bold">My VNPT</span> trên App Store/CH Play`,
    },
    {
      image: stepGetVoucher2,
      desc: `<b>Bước 2:</b> Truy cập ứng dụng My VNPT, chọn <span class="semi-bold">"Đăng nhập/ Đăng ký"</span>`,
    },
    {
      image: stepGetVoucher3,
      desc: `<b>Bước 3:</b> Đăng nhập/Đăng ký ứng dụng My VNPT với số thuê bao VinaPhone bằng OTP hoặc 4G/5G`,
    },
    {
      image: stepGetVoucher4,
      desc: `<b>Bước 4:</b> Chờ nhận ưu đãi điểm VinaPhone Plus được cộng và sử dụng ưu đãi `,
    }
  ];

  const listCard = [
    {
      icon: icon_dual_sim,
      title: "Thời gian diễn ra",
      desc: "Từ ngày 26/02/2025 đến ngày 31/12/2025",
    },
    {
      icon: icon_add_user,
      title: "Đối tượng áp dụng",
      desc: "Dành riêng cho số điện thoại là thuê bao VinaPhone đăng nhập/đăng ký lần đầu tiên trên ứng dụng My VNPT (không áp dụng cho đăng nhập website)",
    },
    {
      icon: icon_calendar,
      title: "Thời hạn điểm khả dụng",
      desc: "Thời hạn điểm 3 tháng kể từ ngày khách hàng được cộng điểm.",
    },
    {
      icon: icon_coupon,
      title: "Thể lệ chương trình",
      desc: "Mỗi khách hàng chỉ nhận 01 ưu đãi cộng điểm trong thời gian diễn ra chương trình",
    }
  ];

  return (
    <div id="ban-moi-vnpt">
      <div className="wrapper">
        <div className="background">
          <div className="bg_decor">
          </div>
          <div className="right_decor">
            <img src={bag_decor_img} />
          </div>
        </div>
        <div className="contentwrapper">
          {/* {isMobile === true && (
            <div className="logo">
              <img src={vnpt_logo} />
            </div>
          )} */}
          {/* {isMobile === false && ( */}
            <div className="logo_desktop">
              <img src={vnpt_logo_desktop} />
            </div>
          {/* )} */}
          <div className="content">
            <div className="title" style={{ marginTop: "32px" }}>
              BẠN MỚI MY VNPT
            </div>
            <div className="title" style={{ marginTop: "16px" }}>
              Đăng nhập lần đầu - Nhận ngay 300 điểm VinaPhone Plus
            </div>
            <div className="contentCTKM" style={{ marginTop: "32px" }}>
              <div className="contentCTKM_img">
                <img src={iconVNPT} alt="" srcset="" />
              </div>
              <div className="contentCTKM_content">
                <span>
                  Dành riêng cho khách hàng là thuê bao VinaPhone
                </span>
              </div>
            </div>

            <div className="banner" style={{ marginTop: "64px" }}>
              <img src={banner} />
            </div>
            <div
              className="contentCTKM_afterBanner"
              style={{ marginTop: "72px" }}
            >
              <div className="subtitle2">
                Mở ra thế giới ưu đãi hấp dẫn!
              </div>
              <div className="contentCTKM_afterBanner_title" style={{ marginTop: "24px" }}>
                Nhận ngay <strong>300 điểm VinaPhone Plus</strong> và đổi điểm để có cơ hội nhận <strong>MIỄN PHÍ</strong> data, thời gian gọi nội mạng,
                <br/>
                ngoại mạng hoặc săn kho quà voucher dịch vụ, đồ gia dụng, công nghệ cao cấp,... cực hot!
              </div>

              {isMobile === false && (
                <div className="button_desktop" style={{ marginTop: "32px" }}>
                  <a
                    className="primary_button"
                    href={"https://myvnpt.page.link/app-vnp"}
                  >
                    Săn ưu đãi ngay
                  </a>
                </div>
              )}

              <div className="ladding-pages-carousel contentCTKM_afterBanner_desktop_carousel">
                <div className="swiper-ladding-pages">
                  <Swiper
                    ref={swiperRef}
                    {...defaftParamsCard}
                  >
                    {listCard.map((item, index) => (
                      <div className="contentCTKM_afterBanner_swiper">
                        <div className="contentCTKM_afterBanner_desktop_content">
                          <div className="contentCTKM_afterBanner_desktop_img">
                            <img src={item.icon} alt="" srcset="" />
                          </div>
                          <div className="contentCTKM_afterBanner_desktop_subcontent">
                            <div className="contentCTKM_afterBanner_desktop_title">{item.title}</div>
                            <div className="contentCTKM_afterBanner_desktop_des">{item.desc}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Swiper>
                  {/* {!isMobile  
                    && (
                    <>
                      <div
                        className={`swiper-button-prev ${!isBeginning ? 'active' : ''}`}
                        onClick={handlePrev}
                      />
                      <div
                        className={`swiper-button-next ${!isEnd ? 'active' : ''}`}
                        onClick={handleNext}
                      />
                    </>
                  )} */}
                </div>
              </div>
            </div>
          </div>
          <div className="subtitle2" style={{ paddingTop: "40px", margin: "0 16px" }}>
            Hướng dẫn đăng nhập ứng dụng My VNPT nhận ngay 300 điểm VinaPhone Plus
          </div>
          <div className="ladding-pages-carousel">
            <div className="swiper-ladding-pages">
              <Swiper
                ref={swiperRef}
                {...defaftParamsVoucher}
              >
                {listStepGetVoucher.map((item, index) => (
                  <div style={{boxSizing: "border-box"}}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "32px" }}>
                      <div className="image">
                        <img src={item.image} alt="" />
                      </div>
                      <div
                        className="content-carousel"
                        dangerouslySetInnerHTML={{
                          __html: item.desc,
                        }}
                      />
                    </div>
                  </div>
                ))}
              </Swiper>
              {/* {!isMobile  
                && (
                <>
                  <div
                    className={`swiper-button-prev ${!isBeginning ? 'active' : ''}`}
                    onClick={handlePrev}
                  />
                  <div
                    className={`swiper-button-next ${!isEnd ? 'active' : ''}`}
                    onClick={handleNext}
                  />
                </>
              )} */}
            </div>
          </div>
          {isMobile === true && (
            <div className="buttons" style={{ marginTop: "86px" }}>
              <a
                className="primary_button"
                href={"https://myvnpt.page.link/app-vnp"}
              >
                Săn ưu đãi ngay
              </a>
            </div>
          )}
        </div>
      </div>
      <div className="footer_ctkm15">
        <div className="content_wrapper">
          <div className="icon_wrapper">
            <div className="logo">
              <img src={myvnpt_logo} alt="" srcset="" />
            </div>
            <div className="download">
              <div className="store_wrapper">
                <div className="icons">
                  <a href={STORE_IOS}><img src={iosStore} alt="" srcset="" /></a>
                  <a href={STORE_ANDROID}><img src={androiStore} alt="" srcset="" /></a>
                </div>
                <div className="text">Truy cập App Store/ Google Play hoặc Quét mã để tải ngay ứng dụng My VNPT</div>
              </div>
              <div className="QRCODE">
                <img src={qrcode} alt="" srcset="" />
              </div>
            </div>
          </div>
          <div className="copyright">© 2018 Bản quyền của Tổng Công ty Truyền thông VNPT-Media</div>
        </div>
      </div>
    </div>
  );
};

export default BanmoiMyVNPT;
